// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"53e110cb","271":"69b84e58"}[chunkId] + ".chunk.js";
};